
import { mapGetters } from 'vuex'
import { EFilter } from '@/helpers/enums'

const DEFAULT_FILTERS = {
  textSearchFilter: true
}

export default {
  name: 'MobileFiltersPanel',

  props: {
    mobile: Boolean,
    searchPools: Boolean,
    searchUserLocation: Boolean,
    searchLocations: Boolean,
    searchWorkPreference: Boolean,
    searchHours: Boolean,
    searchDuration: Boolean,
    searchClosed: Boolean
  },

  data() {
    return {
      openFilters: { ...DEFAULT_FILTERS },
      filterIsOpen: false,
      activeFilterId: null,
      activeFilterComponent: null,
      acttiveFilterTitle: null,
      activeFilterEnum: null,
      filterLabels: {
        pools: '',
        location: '',
        hoursPerWeek: '',
        workPrefs: '',
        duration: ''
      }
    }
  },

  computed: {
    ...mapGetters({
      categorizedPoolsList: 'filters/categorizedPoolsList',
      orphanPoolsList: 'filters/orphanPoolsList',
      preSelectCountry: 'preSelectCountry'
    }),

    filters() {
      return [
        {
          id: 'textSearchFilter',
          EFilter: EFilter.TEXT,
          component: () => import('@/components/app/filters/textSearch.vue'),
          condition: this.mobile || !this.mobile,
          title: this.$t('talent.project.search.text.title'),
          icon: '$vuetify.icons.mdiMagnify'
        },
        {
          id: 'userLocationFilter',
          EFilter: EFilter.USER_LOCATION,
          component: () => import('~/components/app/filters/mobileUserLocation.vue'),
          condition: this.searchUserLocation,
          title: this.$t('talent.project.search.user.your.location'),
          icon: '$vuetify.icons.mdiMapMarkerOutline'
        },
        {
          id: 'workPrefFilter',
          EFilter: EFilter.WORK_PREFS,
          component: () => import('@/components/app/filters/workPreference.vue'),
          condition: this.searchWorkPreference,
          title: this.$t('talent.project.search.work.preference.title'),
          icon: '$vuetify.icons.workType'
        },
        {
          id: 'locationsFilter',
          EFilter: EFilter.LOCATION,
          component: () => import('@/components/app/filters/location.vue'),
          condition: this.searchLocations,
          title: this.$t('talent.project.search.location.title'),
          icon: '$vuetify.icons.mdiDomain'
        },
        {
          id: 'poolCategoriesFilter',
          EFilter: EFilter.POOLS,
          component: () => import('@/components/app/filters/poolCategories.vue'),
          condition: this.showPoolCategoriesFilter,
          title: this.$t('talent.project.search.pools.title'),
          icon: '$vuetify.icons.mdiAccountMultipleOutline'
        },

        {
          id: 'hoursFilter',
          EFilter: EFilter.HOURS,
          component: () => import('@/components/app/filters/hours.vue'),
          condition: this.searchHours,
          title: this.$t('talent.project.search.hours.title'),
          icon: '$vuetify.icons.mdiClockOutline'
        },
        {
          id: 'durationFilter',
          EFilter: EFilter.DURATION,
          component: () => import('@/components/app/filters/duration.vue'),
          condition: this.searchDuration,
          title: this.$t('talent.project.search.duration.title'),
          icon: '$vuetify.icons.mdiCalendarMonthOutline'
        },
        {
          id: 'includeClosedFilter',
          EFilter: EFilter.OPEN_ONLY,
          component: () => import('@/components/app/filters/includeClosed.vue'),
          condition: this.searchClosed,
          title: this.$t('talent.project.search.include.closed.title'),
          icon: '$vuetify.icons.mdiToggleSwitchOffOutline'
        }
      ].filter((item) => item.condition)
    },

    showPoolCategoriesFilter() {
      return this.searchPools && (this.categorizedPoolsList.length || this.orphanPoolsList.length)
    }
  },

  watch: {
    '$route.query': {
      immediate: true,
      handler(data) {
        for (const item of Object.keys(data)) {
          switch (item) {
            case EFilter.TEXT:
              this.$set(this.openFilters, 'textSearchFilter', true)
              break
            case EFilter.POOLS:
              this.$set(this.openFilters, 'poolCategoriesFilter', true)
              break
            case EFilter.LOCATION:
              this.$set(this.openFilters, 'locationsFilter', true)
              break
            case EFilter.HOURS:
              this.$set(this.openFilters, 'hoursFilter', true)
              break
            case EFilter.DURATION:
              this.$set(this.openFilters, 'durationFilter', true)
              break
            case EFilter.WORK_PREFS:
              this.$set(this.openFilters, 'workPrefFilter', true)
              break
            case EFilter.OPEN_ONLY:
              this.$set(this.openFilters, 'includeClosedFilter', true)
              break
            case EFilter.USER_LOCATION:
              this.$set(this.openFilters, 'userLocationFilter', true)
              break
          }
        }
      }
    }
  },

  methods: {
    async cleanupFilters() {
      this.openLoader()
      await this.$router.push({ query: {} })
      this.openFilters = { ...DEFAULT_FILTERS }
      this.closeLoader()
    },

    openLoader() {
      this.$triggerLoader('ACTION', true)
    },

    closeLoader() {
      this.$triggerLoader('ACTION', false)
    },

    closeMobileFilter() {
      this.$emit('close-mobile-filter')
      this.filterIsOpen = false
    },
    handlerActiveFilter(filter) {
      this.activeFilterId = filter.id
      this.activeFilterComponent = filter.component
      this.activeFilterTitle = filter.title
      this.activeFilterEnum = filter.EFilter
    },
    handleClear() {
      // better to use nextTick to make sure the component is updated
      this.$nextTick(() => {
        if (this.$refs.activeFilterComponent && this.$refs.activeFilterComponent.clearFilter) {
          this.$refs.activeFilterComponent.clearFilter()
        } else {
          console.error('Clear filter method is not available on the current component.')
        }
      })
    },

    filterIsFilled(EFilter) {
      return this.$route.query[EFilter]
    }
    // handleUpdateInput(filter, data) {
    //   if (data) {
    //     this.filterLabels[filter] = data
    //   } else {
    //     return ''
    //   }
    // }
  }
}
